
export function isGuidEmpty(val: string): boolean {
  return val == null || val === '' || ( val ).replace(/0/g,'').trim().length < 1;
}
